import { Injectable, Inject } from '@angular/core';
import {FieldType} from '../Models/enum/fieldType';
import {FieldDomainType} from '../Models/enum/fieldDomainType';
import {Validators} from '@angular/forms';
import {CustomValidator} from './custom-validator';
import {FieldMaskType} from '../Models/enum/fieldMaskType';
import {EnumTranslateService} from './enumTranslate-service';
import {DateExibitionFormat} from '../Models/enum/dateExibitionFormat';
import {FieldValidator} from '../Models/enum/fieldValidator';


@Injectable({ providedIn: 'root'})
export class EditFieldsService {

  private translateEnum = EnumTranslateService;

  getEnumArrays() {
    // carregar a lista de tipos do campo
    let enumFieldType = Object.entries(FieldType)
      .filter(e => !isNaN(Number(e[0])) && Number(e[0]) !== 0)
      .map(m => ({ key: m[0], value: m[1], label: this.translateEnum.getFieldTypeEnumTranslated(m[0])  }));

    // carregar a lista de tipos de data
    let enumDateExhibitionFormat = Object.entries(DateExibitionFormat)
      .filter(e => !isNaN(Number(e[0])))
      .map(m => ({ key: m[0], value: m[1], label: this.translateEnum.getEnumDateType(m[0]) }));

    // carregar a lista de tipos de validadores
    let enumFieldValidator = Object.entries(FieldValidator)
      .filter(e => !isNaN(Number(e[0])))
      .map(m => ({ key: m[0], value: m[1], label: this.translateEnum.getEnumFieldValidator(m[0]) }));

    // carregar a lista de dominios disponíveis
    let enumDomain = Object.entries(FieldDomainType)
      .filter(e => !isNaN(Number(e[0])) && Number(e[0]) !== 2)
      .map(m => ({ key: m[0], value: m[1], label: this.translateEnum.getEnumFieldDomainType(m[0]) }));

    return {
      fieldType: enumFieldType,
      dateExibitionFormat: enumDateExhibitionFormat,
      fieldValidator: enumFieldValidator,
      domain: enumDomain
    }
  }

  getTextEnumMaskType() {
    let enumMaskType = Object.entries(FieldMaskType)
      .filter(e => !isNaN(Number(e[0])) &&
        (Number(e[0]) === FieldMaskType.none ||
          Number(e[0]) === FieldMaskType.cpf ||
          Number(e[0]) === FieldMaskType.cnpj ||
          Number(e[0]) === FieldMaskType.phoneNumber))
      .map(m => ({ key: m[0], value: m[1], label: this.translateEnum.getEnumMaskType(m[0]) }));
    return enumMaskType;
  }

  getFloatingEnumMaskType() {
    let enumMaskType = Object.entries(FieldMaskType)
      .filter(e => !isNaN(Number(e[0])) &&
        (Number(e[0]) === FieldMaskType.none ||
          Number(e[0]) === FieldMaskType.twoDecimalPlaces ||
          Number(e[0]) === FieldMaskType.fourDecimalPlaces ||
          Number(e[0]) === FieldMaskType.eightDecimalPlaces))
      .map(m => ({ key: m[0], value: m[1], label: this.translateEnum.getEnumMaskType(m[0]) }));
    return enumMaskType;
  }

  changeFieldType(formData, selectedType: number = 0) {
    let enumMaskType;

    if (formData) {
      if (selectedType === FieldType.text) {
        formData.get('length')
          .setValidators([ Validators.min(1), Validators.max(4000), CustomValidator.numeric ]);

        enumMaskType = this.getTextEnumMaskType();
      } else if (selectedType === FieldType.floating) {

        enumMaskType = this.getFloatingEnumMaskType();
        formData.get('length').clearValidators();
      } else {
        formData.get('length').clearValidators();
      }
    }
    return {enumMaskType: enumMaskType}
  }
}
